import actions from './actions';

const initState = {
    data: []
};

export default function GasReducer(state = initState, action) {
    switch (action.type) {
        case actions.Gas_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
